
export interface Community {
  id: string;
  name: string;
  zone: string;
  members?: number;
  description?: string;
  growth?: string;
  plantHardinessZone?: string;
}

export const communities: Community[] = [
  { id: 'all', name: 'All Communities', zone: 'All' },
  { id: 'produce', name: 'Produce', zone: 'All', members: 1250, description: 'Fresh produce farmers' },
  { id: 'livestock', name: 'Livestock', zone: 'All', members: 890, description: 'Livestock and animal farming' },
  { id: 'dairy', name: 'Dairy', zone: 'All', members: 756, description: 'Dairy farming specialists' },
  { id: 'aquaculture', name: 'Aquaculture', zone: 'All', members: 634, description: 'Fish and aquatic farming' },
  { id: 'hay', name: 'Hay', zone: 'All', members: 567, description: 'Hay and forage production' },
  { id: 'organic', name: 'Organic', zone: 'All', members: 1450, description: 'Organic farming practices' },
  { id: 'urban', name: 'Urban', zone: 'All', members: 890, description: 'Urban and indoor farming' },
  { id: 'homestead', name: 'Homestead/Hobby', zone: 'All', members: 2100, description: 'Small scale and hobby farming' },
  { id: 'bees', name: 'Bees/Apiary', zone: 'All', members: 445, description: 'Beekeeping and honey production' },
  { id: 'dryfarm', name: 'Dry Farm', zone: 'All', members: 320, description: 'Dry farming techniques' },
  { id: 'staples', name: 'Staples', zone: 'All', members: 780, description: 'Staple crop production' },
  { id: 'microfarm', name: 'Microfarm', zone: 'All', members: 650, description: 'Small intensive farming' },
  { id: 'orchard', name: 'Orchard', zone: 'All', members: 590, description: 'Fruit tree cultivation' },
  { id: 'poultry', name: 'Poultry', zone: 'All', members: 720, description: 'Chicken and poultry farming' },
  { id: 'ranch', name: 'Ranch', zone: 'All', members: 480, description: 'Large scale ranching' },
  { id: 'upick', name: 'U-pick', zone: 'All', members: 380, description: 'Pick-your-own farms' },
  { id: 'vineyard', name: 'Vineyard', zone: 'All', members: 340, description: 'Grape growing and wine production' },
  { id: 'greenhouse', name: 'Greenhouse', zone: 'All', members: 890, description: 'Controlled environment agriculture' },
  { id: 'zone-8a', name: 'Zone 8a Growers', zone: '8a', members: 450, description: 'Zone 8a growing community' },
  { id: 'zone-8b', name: 'Zone 8b Growers', zone: '8b', members: 520, description: 'Zone 8b growing community' },
  { id: 'zone-9a', name: 'Zone 9a Growers', zone: '9a', members: 680, description: 'Zone 9a growing community' },
  { id: 'zone-9b', name: 'Zone 9b Growers', zone: '9b', members: 590, description: 'Zone 9b growing community' },
  { id: 'zone-10a', name: 'Zone 10a Growers', zone: '10a', members: 420, description: 'Zone 10a growing community' }
];

// Helper function to get community by id
export const getCommunityById = (id: string): Community | undefined => {
  return communities.find(community => community.id === id);
};

// Helper function to get communities by type
export const getCommunitiesByType = (type: 'zone' | 'category' | 'all'): Community[] => {
  switch (type) {
    case 'zone':
      return communities.filter(community => community.id.startsWith('zone-'));
    case 'category':
      return communities.filter(community => !community.id.startsWith('zone-') && community.id !== 'all');
    case 'all':
    default:
      return communities;
  }
};
